import { render, staticRenderFns } from "./CourseGroupInfoForm.vue?vue&type=template&id=6a4be770"
import script from "./CourseGroupInfoForm.vue?vue&type=script&lang=js"
export * from "./CourseGroupInfoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports